<template>
  <div class="send-team">
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">队伍调派</h2>
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="队伍名称" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写队伍名称"></Input>
          </FormItem>
          <FormItem label="发起人" prop="dutyTelephone">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写负责单位电话"></Input>
          </FormItem>
          <FormItem label="事件名称" prop="responsibleUnitId">
            <Input v-model="formValidate.dutyTelephone" placeholder="请填写负责单位电话"></Input>
          </FormItem>
          <FormItem label="任务状态" prop="address">
            <Input v-model="formValidate.address" placeholder="请填写详细地址"></Input>
          </FormItem>
          <FormItem label="任务描述" prop="introduce">
            <Input v-model="formValidate.introduce" type="textarea" :autosize="{minRows: 5}"/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "sendResource",
  data() {
    return {
      eventList: [],
      // teamInfo: {},
      formValidate: {
        name: '',
        responsibleUnitId: '',
        personInCharge: '',
        personInChargePhone: '',
        dutyTelephone: '',
        countPeople: '',
        teamType: 0, //1-政府队伍，2-企业队伍，3-社会队伍
        establishedTime: '',
        responsibleAreaId: '',
        responsibleStreetId: '',
        address: '',
        longitude: '',
        dimension: '',
        applicableEventTypes: 1,
        superviseLevel: 1,//1-市级，2-区县级，3-镇街级
        introduce: '',
        remarks: '',
        annex: ''
      },
      ruleValidate: {},
    }
  },
  mounted() {
    this.getAllEvents()
    if (this.$route.params.row) {
      this.teamInfo = this.$route.params.row.emergencyTeam
      this.teamInfo.applicableEventTypes = this.teamInfo.applicableEventTypes.toString()
      this.formValidate = this.teamInfo
    }
  },
  methods: {
    //获取事件类型/api/event/getAll
    getAllEvents() {
      this.$http.get('/api/event/getAll').then(res => {
        console.log(res)
        this.eventList = res.data.data
        // this.eventList = this.eventList.Map(item => item.id = Number(item.id))
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$http.post('/api/team/emergencyTeams', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('新增完成！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyTeam'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editTeam(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$http.put('/api/team/emergencyTeams', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('修改完成！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyTeam'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped>
.send-team{}
</style>
